/* =========================================================================
   Thoson: camino de puntos entre secciones imagen + texto seguidas (ficha).
   v17.11. Lo carga sections/thx-header.liquid solo en plantillas de producto.

   Une cada seccion con la anterior cuando las dos son imagen + texto y
   estan pegadas (una racha). Nunca antes de la primera ni despues de la
   ultima. Escritorio: del pie del marco de una foto a la cabeza del marco
   de la siguiente. Movil: del final del texto al marco siguiente, entrando
   por el lado contrario a su mancha (ver thx-iwt.css).

   El marco es la caja .image-with-text__media-item: su padding es el anillo
   blanco, asi que sus bordes son los del marco.

   Si en escritorio el texto es mas alto que la foto y se mete en el camino,
   el camino baja recto hasta pasar el texto, cruza, y vuelve a bajar recto
   al marco. Si no queda sitio para cruzar, no se dibuja.

   Las medidas salen de offsetLeft/offsetTop, que no cuentan transform, asi
   que la animacion de entrada del tema no las tuerce. Se redibuja al cambiar
   de tamano, al cargar las fotos y en el editor de temas.
   ========================================================================= */
(function () {
  if (window.thxIwtRoute) return;
  window.thxIwtRoute = true;

  var SVG = 'http://www.w3.org/2000/svg';
  var HOST = '.image-with-text--no-overlap';
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function box(el) {
    var w = el.offsetWidth, h = el.offsetHeight, x = 0, y = 0;
    while (el) { x += el.offsetLeft; y += el.offsetTop; el = el.offsetParent; }
    return { x: x, y: y, w: w, h: h, b: y + h };
  }

  function hostOf(sec) {
    return sec && sec.querySelector ? sec.querySelector(HOST) : null;
  }

  function parts(host) {
    var m = host.querySelector('.image-with-text__media-item');
    var t = host.querySelector('.image-with-text__text-item');
    if (!m || !t || !m.offsetWidth || !t.offsetWidth) return null;
    return { m: box(m), t: box(t) };
  }

  function f(n) { return n.toFixed(1); }

  function draw() {
    var old = document.querySelectorAll('.thx-iwt-route');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

    var mobile = MOBILE.matches;
    var hosts = document.querySelectorAll(HOST);
    for (var j = 0; j < hosts.length; j++) {
      var h = hosts[j];
      var sec = h.closest('.shopify-section');
      if (!sec) continue;
      var prevSec = sec.previousElementSibling;
      var ph = hostOf(prevSec);
      if (!ph) continue;

      /* Puesto de esta seccion en la racha: 2 = la segunda. */
      var place = 2;
      var s = prevSec;
      while (s.previousElementSibling && hostOf(s.previousElementSibling)) { place++; s = s.previousElementSibling; }
      var even = place % 2 === 0;

      var A = parts(ph), B = parts(h);
      if (!A || !B) continue;
      var x0, y0, x3, y3, ya, yb, k1, k2;

      if (mobile) {
        /* Sale de lo que cierra la seccion anterior (el texto, o la foto si
           el movil la pone debajo) y llega a lo que abre la siguiente. */
        var endA = A.t.b >= A.m.b ? A.t : A.m;
        var startB = B.m.y <= B.t.y ? B.m : B.t;
        x0 = even ? endA.x + 32 : endA.x + endA.w - 32;
        y0 = endA.b + (endA === A.t ? 6 : 4);
        x3 = startB.x + startB.w * (even ? 0.8 : 0.2);
        y3 = startB.y - 4;
        ya = y0;
        yb = y3;
        if (yb - ya < 24) continue;
        k1 = (yb - ya) * 0.5;
        k2 = (yb - ya) * 0.6;
      } else {
        x0 = A.m.x + A.m.w / 2;
        y0 = A.m.b + 4;
        x3 = B.m.x + B.m.w / 2;
        y3 = B.m.y - 4;
        ya = Math.max(y0, A.t.b + 10);
        yb = Math.min(y3, B.t.y - 10);
        if (yb - ya < 60) continue;
        k1 = k2 = (yb - ya) * 0.62;
      }

      var left = Math.min(x0, x3) - 10;
      var top = y0 - 10;
      var w = Math.abs(x3 - x0) + 20;
      var ht = (y3 - y0) + 20;
      var X0 = x0 - left, X3 = x3 - left;
      var Y0 = y0 - top, YA = ya - top, YB = yb - top, Y3 = y3 - top;

      var d = 'M' + f(X0) + ' ' + f(Y0);
      if (YA > Y0 + 0.5) d += 'L' + f(X0) + ' ' + f(YA);
      d += 'C' + f(X0) + ' ' + f(YA + k1) + ' ' + f(X3) + ' ' + f(YB - k2) + ' ' + f(X3) + ' ' + f(YB);
      if (Y3 > YB + 0.5) d += 'L' + f(X3) + ' ' + f(Y3);

      var svg = document.createElementNS(SVG, 'svg');
      svg.setAttribute('class', 'thx-iwt-route' + (mobile ? ' is-m' : ''));
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('width', String(Math.round(w)));
      svg.setAttribute('height', String(Math.round(ht)));
      svg.setAttribute('viewBox', '0 0 ' + Math.round(w) + ' ' + Math.round(ht));
      var H = box(h);
      svg.style.left = Math.round(left - H.x) + 'px';
      svg.style.top = Math.round(top - H.y) + 'px';
      var path = document.createElementNS(SVG, 'path');
      path.setAttribute('d', d);
      svg.appendChild(path);
      h.insertBefore(svg, h.firstChild);
    }
  }

  /* setTimeout y no requestAnimationFrame: en una pestana oculta rAF no
     corre, y la ficha abierta en segundo plano tiene que llegar dibujada. */
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(draw, 60);
  }

  function start() {
    var hosts = document.querySelectorAll(HOST);
    if (!hosts.length) return;
    schedule();
    window.addEventListener('resize', schedule);
    window.addEventListener('load', function () { schedule(); setTimeout(schedule, 1500); });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    if (MOBILE.addEventListener) { MOBILE.addEventListener('change', schedule); }
    else if (MOBILE.addListener) { MOBILE.addListener(schedule); }
    if (window.ResizeObserver) {
      /* border-box: un cambio de padding tambien mueve los marcos. */
      var ro = new ResizeObserver(schedule);
      for (var i = 0; i < hosts.length; i++) {
        ro.observe(hosts[i], { box: 'border-box' });
        var m = hosts[i].querySelector('.image-with-text__media-item');
        if (m) ro.observe(m, { box: 'border-box' });
        var t = hosts[i].querySelector('.image-with-text__text-item');
        if (t) ro.observe(t, { box: 'border-box' });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
